import objectReduce from 'fast-loops/lib/objectReduce';

import generateCSSSupportRule from './generateCSSSupportRule';

export default function cssifySupportRules(supportRules) {
  return objectReduce(supportRules, function (css, cssRules, support) {
    if (cssRules.length > 0) {
      css += generateCSSSupportRule(support, cssRules);
    }

    return css;
  }, '');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/cssifySupportRules.js
// module id = 77
// module chunks = 0